import { config } from '@config'
import { storage } from '@services/storageService'
import axios from 'axios'
import { VIPBuyingSessionProduct } from '@services/wholesale/productService'
export class CommonService {
  getClientAssormentProducts = async (
    buyingSessionGroupId: string,
    clientId: string
  ): Promise<VIPBuyingSessionProduct[]> => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${buyingSessionGroupId}/assortment/client/${clientId}`
      const accessToken: string = storage.getItem('access_token')
      const response: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response?.data
    } catch (e) {
      console.log(e)
    }
  }
  getDoorAssormentProducts = async (
    buyingSessionGroupId: string,
    clientId: string,
    doorId: string
  ): Promise<VIPBuyingSessionProduct[]> => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${buyingSessionGroupId}/assortment/client/${clientId}/door/${doorId}`
      const accessToken: string = storage.getItem('access_token')
      const response: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response?.data
    } catch (e) {
      console.log(e)
    }
  }
}
